module.exports = {
    home: 'Home',
    products: 'Products',
    suggest: 'Advantage',
    process: 'Process',
    network_income:'Whole network income',
    partners:'Partners',
    sign_in: 'Sign in',
    sign_up: 'Sign up',
}
